
import React from "react";
import ECharts from "echarts-for-react";
import { getDate, getTime, getDay } from "components/common/dateTime";

export default function EnergyComponentChartSessionTime(props) {
  var xAxisData = [];
  var yAxisData = [];
  // if (props.data != undefined) {
  //   props.data.swapTime.
  //   console.log('swap.swaptime',props.data.swapTime)
  //   props.data.map(function (obj) {
  //     console.log('',obj);
  //     xAxisData.push(getTime(obj));
  //     if (props.selectValue === "HOUR_24" || props.selectValue === "HOUR_12") {
  //       xAxisData.push(getTime(obj));
  //     } else if (props.selectValue === "WEEK") {
  //       xAxisData.push(getDay(obj.swapTime));
  //     } else {
  //       xAxisData.push(getDate(obj.swapTime));
  //     }
  //     if (obj.yaxis === null || obj.yaxis === 0) {
  //       obj.yaxis = Math.round(Math.random() * 10);
  //       console.log('obj bv',obj.swapCount)
  //       yAxisData.push(obj.swapCount);
  //     } else {
  //       yAxisData.push(obj.swapCount);
  //       console.log('obj esle',obj.swapCount)
  //     }
  //   });
  // }

  var swapTime = props?.data?.swapTime;
  var swapCount = props?.data?.swapCount;
  var swapLength;

  if (swapCount == undefined) {
    swapCount = [0, 0, 0, 0, 0, 0, 0];
  } else {
    swapCount = props.data.swapCount;
  }
  if (swapTime == undefined) {
    swapTime = [0, 0, 0, 0, 0, 0, 0];
  } else {
    swapTime = props.data.swapTime;
  }

  var largest = swapCount[0];

  for (var i = 0; i < swapCount?.length; i++) {
    if (largest < swapCount[i]) {
      largest = swapCount[i];
    }
  }
  swapLength = largest?.toString()?.length;

  var option = {
    xAxis: {
      type: "category",
      nameGap: 30,
      name: "Session time",
      nameLocation: "middle",
      data: swapTime,
      // data: [20, 30, 40, 50, 60, 70, 80],
    },
    yAxis: {
      type: "value",
      nameLocation: "middle",
      nameGap: swapLength > 3 ? "50" : "32",
      name: "Number of Swaps",
    },
    grid: {
      left: "12%",
      right: "5%",
      bottom: "17%",
      containLabel: true,
      height: "65%",
      width: "auto",
    },
    series: [
      {
        data: swapCount,
        // data: [210, 310, 170, 380, 150, 320, 180],
        type: "bar",
        showBackground: true,
        color: "#414ACD",
        label: {
          show: false,
          position: "top",
        },
        backgroundStyle: {
          color: "rgba(180, 180, 180, 0.2)",
        },
        itemStyle: {
          emphasis: {
            barBorderRadius: [50, 50],
          },
          normal: {
            barBorderRadius: [50, 50, 0, 0],
          },
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };
  return (
    <div>
      <ECharts option={option} />
    </div>
  );
}
